// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "category.proto" (package "category", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CategoryService } from "./category";
import type { DeleteCategoryResponse } from "./category";
import type { DeleteCategoryRequest } from "./category";
import type { UpdateCategoryResponse } from "./category";
import type { UpdateCategoryRequest } from "./category";
import type { CreateCategoryResponse } from "./category";
import type { CreateCategoryRequest } from "./category";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllCategoriesResponse } from "./category";
import type { GetAllCategoriesRequest } from "./category";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service category.CategoryService
 */
export interface ICategoryServiceClient {
    /**
     * @generated from protobuf rpc: GetAllCategories
     */
    getAllCategories(input: GetAllCategoriesRequest, options?: RpcOptions): UnaryCall<GetAllCategoriesRequest, GetAllCategoriesResponse>;
    /**
     * @generated from protobuf rpc: CreateCategory
     */
    createCategory(input: CreateCategoryRequest, options?: RpcOptions): UnaryCall<CreateCategoryRequest, CreateCategoryResponse>;
    /**
     * @generated from protobuf rpc: UpdateCategory
     */
    updateCategory(input: UpdateCategoryRequest, options?: RpcOptions): UnaryCall<UpdateCategoryRequest, UpdateCategoryResponse>;
    /**
     * @generated from protobuf rpc: DeleteCategory
     */
    deleteCategory(input: DeleteCategoryRequest, options?: RpcOptions): UnaryCall<DeleteCategoryRequest, DeleteCategoryResponse>;
}
/**
 * @generated from protobuf service category.CategoryService
 */
export class CategoryServiceClient implements ICategoryServiceClient, ServiceInfo {
    typeName = CategoryService.typeName;
    methods = CategoryService.methods;
    options = CategoryService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllCategories
     */
    getAllCategories(input: GetAllCategoriesRequest, options?: RpcOptions): UnaryCall<GetAllCategoriesRequest, GetAllCategoriesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllCategoriesRequest, GetAllCategoriesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCategory
     */
    createCategory(input: CreateCategoryRequest, options?: RpcOptions): UnaryCall<CreateCategoryRequest, CreateCategoryResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCategoryRequest, CreateCategoryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCategory
     */
    updateCategory(input: UpdateCategoryRequest, options?: RpcOptions): UnaryCall<UpdateCategoryRequest, UpdateCategoryResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCategoryRequest, UpdateCategoryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCategory
     */
    deleteCategory(input: DeleteCategoryRequest, options?: RpcOptions): UnaryCall<DeleteCategoryRequest, DeleteCategoryResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteCategoryRequest, DeleteCategoryResponse>("unary", this._transport, method, opt, input);
    }
}
